import { useState, Fragment, useRef, useEffect } from 'react';
import '../../assets/css/account.css'
import { TrashIcon } from '@heroicons/react/outline';
import Layout from './../../components/Layout/Layout';
import React from "react";
import { Link } from "react-router-dom";
import IdCard from '../../assets/images/id-card.png'
import Utility from '../../assets/images/receipt.png'
import Signature from '../../assets/images/signature.png'
import Passport from '../../assets/images/passport.png'
import Reference from '../../assets/images/reference.png';
import Letter from '../../assets/images/letter.png';
import Board from '../../assets/images/board.png'
import Certificate from '../../assets/images/certificate.png'
import Form from '../../assets/images/form.png'
import AccountServices from '../../services/AccountServices';
import { Dialog, Transition } from '@headlessui/react'
import fire from './../../utils/Toastr';



export default function DocumentReview() {
  const id = new URLSearchParams(window.location.search).get("id");
  const [open, setOpen] = useState(false)

  const cancelButtonRef = useRef(null)
  const [doc, setDoc] = useState([])
  const [acct, setAcct] = useState("")
  const [docTAG, setTag] = useState("")
  const [acctType, setAccountType] = useState("")

  const listDocument = async () => {
    const resp = await AccountServices.listDocument(id);
    if (resp) {
      setDoc([...resp.data])
      setAccountType(resp.data[0].accountClass)
      setAcct(resp.data[0].accountNumber)

    }
  }
  const handleOpen = async (documentTag) => {
    setOpen(true);
    setTag(documentTag)
  }
  const handleClose = () => {
    setOpen(false)
  }
  
  const deleteDoc = async (tag) => {
    const resp = await AccountServices.deleteDocument({ documentTag: docTAG, accountNumber: id })
    if(resp){
      fire("success", resp.message);
    }
    setOpen(false)
    window.location.reload();
  }
  const updateDoc = async (doc, Id) => {
    const resp = await AccountServices.updateDoc({ documentTag: doc, accountNumber:Id});
    if(resp){
      fire("success", resp.message);
    }
  }

  useEffect(() => {
    listDocument();
  }, [])
  return (<>

    <Layout title="Review Documents" pageTag={'account'} current={'/review/document'}>
      <React.Fragment>
        <main>
          <div className='max-w-7xl mx-auto'>
            <div className=''>
              
              <div className='flex justify-center'><h4 className='font-bold'>{acct}</h4></div>

              <div className="px-4 sm:px-6 lg:px-8">
                <div className="sm:flex sm:items-center">
                  <div className="sm:flex-auto flex">
                    <div className="mt-1 relative">
                      <h2 className="font-semibold text-gray-900">Customer's Uploads</h2>
                    </div>
                  </div>
                </div>
                <div className="mt-8 flex flex-col">
                  <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
                    {doc.length === 0  ? (
                       <div className=" mt-8"> No document available to show. </div>
                    ) : 
                    <>
                    <div className="inline-block min-w-full py-2 align-middle md:px-6 lg:px-8">
                   <ul  className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4">
                     {doc.map((person, i) => (
                       <>
                         <li key={i} className="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200">
                           {person.uploadUrl == null ? "" :
                             <>
                               {person.documentTag === "id_card" && person.uploadUrl == null ? "" :
                                 <div className="flex-1 flex flex-col p-8">
                                   <div className="flex">
                                     <img className="w-32 h-32 flex-shrink-0 mx-auto" src={person.uploadUrl} alt="" />
                                     <button
                                       onClick={() => handleOpen(person.documentTag)}
                                       value={person.documentTag}
                                       className="bin">
                                       <TrashIcon className="w-5 h-5 text-gray-400 " aria-hidden="true" />
                                     </button>
                                   </div>
                                   <Link to="/account/comments">
                                     <h3 className="mt-6 text-gray-900 text-sm ">{person.documentDescription}</h3>
                                   </Link>
                                 </div>
                               }
                               {person.documentTag.toLowerCase() === "utility_bill" &&
                                 <div className="flex-1 flex flex-col p-8">
                                   <div className="flex">
                                     <img className="w-32 h-32 flex-shrink-0 mx-auto" src={person.uploadUrl} alt="" />
                                     <button
                                       // onClick={() => Delete()} 
                                       onClick={() => setOpen(true)}
                                       value={person.documentTag} className="bin">
                                       <TrashIcon className="w-5 h-5 text-gray-400 " aria-hidden="true" />

                                     </button>
                                   </div>
                                   <Link to="/account/comments">
                                     <h3 className="mt-6 text-gray-900 text-sm ">{person.documentDescription}</h3>
                                   </Link>
                                 </div>
                               }
                               {person.documentTag.toLowerCase() === "signature" &&
                                 <div className="flex-1 flex flex-col p-8">
                                   <div className="flex">
                                     <img className="w-32 h-32 flex-shrink-0 mx-auto" src={person.uploadUrl} alt="" />
                                     <button
                                       onClick={handleOpen}
                                       value={person.documentTag} className="bin">
                                       <TrashIcon className="w-5 h-5 text-gray-400 " aria-hidden="true" />

                                     </button>
                                   </div>
                                   <Link to="/account/comments">
                                     <h3 className="mt-6 text-gray-900 text-sm ">{person.documentDescription}</h3>
                                   </Link>
                                 </div>
                               }
                               {person.documentTag.toLowerCase() === "passport" &&
                                 <div className="flex-1 flex flex-col p-8">
                                   <div className="flex">
                                     <img className="w-32 h-32 flex-shrink-0 mx-auto" src={person.uploadUrl} alt="" />
                                     <button
                                       onClick={handleOpen}
                                       value={person.documentTag} className="bin">
                                       <TrashIcon className="w-5 h-5 text-gray-400 " aria-hidden="true" />

                                     </button>
                                   </div>
                                   <Link to="/account/comments">
                                     <h3 className="mt-6 text-gray-900 text-sm ">{person.documentDescription}</h3>
                                   </Link>
                                 </div>
                               }
                               {person.documentTag.toLowerCase() === "references" &&
                                 <div className="flex-1 flex flex-col p-8">
                                   <div className="flex">
                                     <img className="w-32 h-32 flex-shrink-0 mx-auto" src={person.uploadUrl} alt="" />
                                     <button
                                       onClick={handleOpen}
                                       value={person.documentTag} className="bin">
                                       <TrashIcon className="w-5 h-5 text-gray-400 " aria-hidden="true" />

                                     </button>
                                   </div>
                                   <Link to="/account/comments">
                                     <h3 className="mt-6 text-gray-900 text-sm ">{person.documentDescription}</h3>
                                   </Link>
                                 </div>
                               }
                               {person.documentTag.toLowerCase() === "signatories" &&
                                 <div className="flex-1 flex flex-col p-8">
                                   <div className="flex">
                                     <img className="w-32 h-32 flex-shrink-0 mx-auto" src={person.uploadUrl} alt="" />
                                     <button
                                       onClick={handleOpen}
                                       value={person.documentTag} className="bin">
                                       <TrashIcon className="w-5 h-5 text-gray-400 " aria-hidden="true" />

                                     </button>
                                   </div>
                                   <Link to="/account/comments">
                                     <h3 className="mt-6 text-gray-900 text-sm ">{person.documentDescription}</h3>
                                   </Link>
                                 </div>
                               }
                             </>
                           }

                           <div>
                           </div>
                         </li>
                       </>

                     ))}
                   </ul>

                 </div>
                   </>
                    }
                   
                   
                  </div>
                </div>
                <div className='mt-6'>
                  <div className='my-6'>
                    <h2 className="font-semibold text-gray-900"> {acctType === "DOMIND" ? "Required Uploads" : "Required Uploads(Savings)"}</h2>
                    <p>Please indicate if the customer has provided the following documents</p>
                  </div>
                  {doc.map((person, i) => (
                    <div key={i}>
                      {person.documentTag === "id_card" &&
                        <div className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">

                          <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                            <div className=' flex flex-col items-center'>
                              <img src={IdCard} alt='card' className='w-14' />
                              <p className='text-center mt-2 text-sm'>Identity Card</p>
                            </div>
                          </div>
                          <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                            <div className=''>
                              <p>A valid Identity Card should be either  an International Passport , Driver's License National ID or Voter's card</p>
                              <p className='text-gray-500'>Did the customer provide a valid  Identity Card?</p>
                              <div className='flex'>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag, person.id)}
                                  className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                >Yes</button>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag, person.id)}
                                  className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                >No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {person.documentTag === "utility_bill" &&
                        <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                          <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                            <div className=' flex flex-col text-sm  items-center'>
                              <img src={Utility} alt='utility' className='w-14' />
                              <p className='text-center mt-2 text-sm'>Utility Bill</p>
                            </div>
                          </div>
                          <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                            <div className=''>
                              <p>The customer’s Utility bill (Electricity/Water/Telephone/Waste) – within the last 3 months</p>
                              <p className='text-gray-500'>Did the customer provide a Utility Bill?</p>
                              <div className='flex'>
                                <button
                                  type="button"
                                  value="utility_bill"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                >Yes</button>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                >No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {person.documentTag === "signature" &&
                        <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                          <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                            <div className=' flex flex-col text-sm  items-center'>
                              <img src={Signature} alt='signature' className='w-14' />
                              <p className='text-center mt-2 text-sm'>Signature</p>
                            </div>
                          </div>
                          <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                            <div className=''>
                              <p>The customer’s legible and recognized official signature</p>
                              <p className='text-gray-500'>Did the customer provide a signature?</p>
                              <div className='flex'>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                >Yes</button>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                >No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {person.documentTag === "passport" &&
                        <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                          <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                            <div className=' flex flex-col  items-center'>
                              <img src={Passport} alt='passport' className='w-14' />
                              <p className='text-center mt-2 text-sm '>Passport Photograph</p>
                            </div>
                          </div>
                          <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                            <div className=''>
                              <p>A clear and visible passport photograph of the customer’s face</p>
                              <p className='text-gray-500'>Did the customer provide a clear passport photograph?</p>
                              <div className='flex'>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                >Yes</button>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                >No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {person.documentTag === "references" &&
                        <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                          <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                            <div className=' flex flex-col  items-center'>
                              <img src={Reference} alt='passport' className='w-14' />
                              <p className='text-center mt-2 text-sm '>References</p>
                            </div>
                          </div>
                          <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                            <div className=''>
                              <p>The customer is required to provide two references</p>
                              <p className='text-gray-500'>Did the customer provide two valid references?</p>
                              <div className='flex'>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                >Yes</button>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                >No</button>
                              </div>
                            </div>
                          </div>
                        </div>
                      }
                      {person.documentTag === "signatories" &&
                        <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                          <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                            <div className=' flex flex-col  items-center'>
                              <img src={Letter} alt='passport' className='w-14' />
                              <p className='text-center mt-2 text-sm '>Letter of Introduction</p>
                            </div>
                          </div>
                          <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                            <div className=''>
                              <p>A letter of introduction from the different signatories to the customer’s account</p>
                              <p className='text-gray-500'>Did the customer provide a letter of introduction?</p>
                              <div className='flex'>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                                >Yes</button>
                                <button
                                  type="button"
                                  onClick={() => updateDoc(person.documentTag)}
                                  className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                                >No</button>

                              </div>
                            </div>
                          </div>
                        </div>
                      }
                    </div>
                  ))}



                  {/* Corporate account details */}
                  <div className='mt-5 hidden'>
                    <div className="mt-3 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                      <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                        <div className=' flex flex-col items-center'>
                          <img src={Board} alt='card' className='w-14' />
                          <p className='text-center mt-2 text-sm'>Board Resolution</p>
                        </div>
                      </div>
                      <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                        <div className=''>
                          <p>A Board Resolution outlining the decision of the Board of Directors</p>
                          <p className='text-gray-500'>Did the customer provide a valid Board Resolution?</p>
                          <div className='flex'>
                            <button
                              type="button"
                              className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                            >Yes</button>
                            <button
                              type="button"
                              className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                            >No</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                      <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                        <div className=' flex flex-col text-sm  items-center'>
                          <img src={Certificate} alt='utility' className='w-14' />
                          <p className='text-center mt-2 text-sm'>Certificate of Incorporation</p>
                        </div>
                      </div>
                      <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                        <div className=''>
                          <p>Certificate of Incorporation of the Company as issued by the Corporate Affairs Commission</p>
                          <p className='text-gray-500'>Did the customer provide a Certificate of Inicorporation?</p>
                          <div className='flex'>
                            <button
                              type="button"
                              className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                            >Yes</button>
                            <button
                              type="button"
                              className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                            >No</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                      <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                        <div className=' flex flex-col text-sm  items-center'>
                          <img src={Form} alt='signature' className='w-14' />
                          <p className='text-center mt-2 text-sm'>Form C02</p>
                        </div>
                      </div>
                      <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                        <div className=''>
                          <p>CAC Form 2 - Statement of Share Capital and Return of Allotment of Shares</p>
                          <p className='text-gray-500'>Did the customer provide Form C02?</p>
                          <div className='flex'>
                            <button
                              type="button"
                              className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                            >Yes</button>
                            <button
                              type="button"
                              className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                            >No</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                      <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                        <div className=' flex flex-col  items-center'>
                          <img src={Form} alt='passport' className='w-14' />
                          <p className='text-center mt-2 text-sm '>Form C07</p>
                        </div>
                      </div>
                      <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                        <div className=''>
                          <p>CAC Form 7 - Particulars of Directors</p>
                          <p className='text-gray-500'>Did the customer provide Form C07?</p>
                          <div className='flex'>
                            <button
                              type="button"
                              className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                            >Yes</button>
                            <button
                              type="button"
                              className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                            >No</button>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 grid grid-cols-1 gap-5 sm:gap-6 sm:grid-cols-2 lg:grid-cols-4">
                      <div className='border flex-col col-span-1 flex shadow-sm rounded-md border shadow-md rounded-md p-5 w-38'>
                        <div className=' flex flex-col  items-center'>
                          <img src={Reference} alt='passport' className='w-14' />
                          <p className='text-center mt-2 text-sm '>Corporate References</p>
                        </div>
                      </div>
                      <div className='border col-span-3 flex shadow-sm rounded-md  shadow-md border-sm p-4'>
                        <div className=''>
                          <p>The customer is required to provide two corporate references</p>
                          <p className='text-gray-500'>Did the customer provide two valid corporate references?</p>
                          <div className='flex'>
                            <button
                              type="button"
                              className="mr-5 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                            >Yes</button>
                            <button
                              type="button"
                              className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                            >No</button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                </div>
                {/* Required details */}
                <div className='mt-5'>
                  <div className='mt-5'>
                    <p>Required Details</p>
                    <p className='text-gray-400'>Plese indicate if customer has provided the following details</p>
                  </div>
                  <div className='mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8'>
                    <div className=' flex-col col-span-4 flex  border-r-4 pr-5 border-gray-300'>
                      <p className='uppercase'>personal information</p>
                      <div className='mt-5 grid grid-cols-1  sm:gap-3 sm:grid-cols-4 lg:grid-cols-8'>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Marital Status?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Mother Maiden's Name?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>National ID Number?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Are you a Nigerian?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Resident Permit Number?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                      </div>



                    </div>
                    <div className='flex-col col-span-4 flex  ml-4'>
                      <p className='uppercase'>next of kin</p>
                      <div className='mt-5 grid grid-cols-1  sm:gap-3 sm:grid-cols-4 lg:grid-cols-8'>
                        <div className='border border-md  rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Surname?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>First Name?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Middle Name?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Date of birth?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Gender?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-4 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Relationship?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Corporate details */}
                  <div className='mt-5 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-8 hidden'>
                    <div className=' flex-col col-span-6 flex '>
                      <p className='uppercase'>business information</p>
                      <div className='mt-5 grid grid-cols-2  sm:gap-3 sm:grid-cols-2 lg:grid-cols-6'>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Nature of Business?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Sector/Industry?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2  flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Location of registered business?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Operating business address?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>

                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Registered Business address?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Business Phone Number?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Business Email Address?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>Business Website ?</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                        <div className='border border-md rounded-md shadow-md flex-col col-span-2 flex  p-2 text-center'>
                          <div className='my-5'>
                            <p className='mb-2 text-xs'>SCUML Registration Number</p>
                            <div className='flex items-center align-center justify-center'>
                              <button
                                type="button"
                                className="mr-3 inline-flex items-center justify-center rounded-md border border-dark btn-secondary px-4 py-2 text-sm font-medium text-dark shadow-sm sm:w-auto"
                              >Yes</button>
                              <button
                                type="button"
                                className=" inline-flex items-center justify-center rounded-md border border-transparent btn-primary px-4 py-2 text-sm font-medium text-white shadow-sm sm:w-auto"
                              >No</button>
                            </div>
                          </div>
                        </div>
                      </div>

                    </div>

                  </div>
                </div>
              </div>

            </div>
          </div>
        </main>
        <Transition.Root show={open} as={Fragment}>
          <Dialog as="div" className="relative z-10" initialFocus={cancelButtonRef} onClose={handleClose}>
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0"
              enterTo="opacity-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100"
              leaveTo="opacity-0"
            >
              <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
            </Transition.Child>

            <div className="fixed z-10 inset-0 overflow-y-auto">
              <div className="flex items-end sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
                <Transition.Child
                  as={Fragment}
                  enter="ease-out duration-300"
                  enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                  enterTo="opacity-100 translate-y-0 sm:scale-100"
                  leave="ease-in duration-200"
                  leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                  leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                  <Dialog.Panel className="relative bg-white rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:max-w-xs sm:w-full sm:p-6">
                    <div>
                      <div className="mt-3 text-center sm:mt-5">
                        <Dialog.Title as="h3" className="text-lg leading-6 font-medium text-gray-900">
                          Hey, wait!!
                        </Dialog.Title>
                        <div className="mt-2">
                          <p className="text-sm text-gray-500">
                            Are you sure you want <br /> to delete this file?
                          </p>
                        </div>
                      </div>
                    </div>
                    <div className="mt-5 sm:mt-6 sm:flex sm:grid-cols-2 sm:gap-3 sm:grid-flow-row-dense">
                      <button
                        type="button"
                        className="w-full inline-flex justify-center rounded-md border border-gray-900 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-900  sm:col-start-2 sm:text-sm"
                        onClick={() =>deleteDoc (doc.documentTag)}
                      >
                        Yes, I do
                      </button>
                      <button
                        type="button"
                        className="mt-3 w-full inline-flex justify-center rounded-md border bg-dark border-gray-300 shadow-sm px-4 py-2  text-base font-medium text-white btn-primary sm:mt-0 sm:col-start-1 sm:text-sm"
                        onClick={handleClose}
                        ref={cancelButtonRef}
                      >
                        No, I dont
                      </button>
                    </div>
                  </Dialog.Panel>
                </Transition.Child>
              </div>
            </div>
          </Dialog>
        </Transition.Root>
      </React.Fragment>
    </Layout>


  </>);
}